import React, { useContext, useState } from 'react';
import moment from 'moment';
import { Grid, Button, Stack } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Formik, Form } from 'formik';
import { AutocompleteField, InputField, UploadDocField, DatePickerField } from '../../../components/form-fields';

import { axiosPrivate } from '../../../common/axiosPrivate';
import NotificationContext from '../../../context/notificationContext';
import AuthContext from '../../../context/authContext';

import validationSchema from './form-model/validationSchema';
import formModel from './form-model/formModel';
import initialValues from './form-model/initialValues';

export default function DokumenAllForm({data, pegawais, handleCloseModal, handleUpdateTable}) {
  const { user } = useContext(AuthContext);
  const notificationCtx = useContext(NotificationContext);
  const { formId, formField } = formModel;
  const { pegawai, dokumen, nama, keterangan, penyerah, penerima, tglSerah, tglTerima } = formField;
  const [selectedId, setSelectedId] = useState();

  const handleInitialValues = data !== undefined
    ? {
      dokumen: `https://drive.google.com/file/d/${data.dokumen?.id}/view`,
      pegawai: data.kodePegawai,
      nama: data.nama,
      keterangan: data.keterangan,
      penyerah: data.penyerah,
      penerima: data.penerima,
      tglSerah: data.tglSerah,
      tglTerima: data.tglTerima
    }
    : initialValues;

  const handleMessage = async (params) => {
    const success = params?.success;

    if (success) {
      notificationCtx.setup({
        severity: 'success',
        title: 'Success',
        message: params?.message
      });
    } else {
      notificationCtx.setup({
        severity: 'error',
        title: 'Error',
        message: params?.message
      });
    }
  };

  const handleSubmit = async (values, { resetForm, setSubmitting }) => {
    const { pegawai, dokumen, nama, keterangan, penyerah, penerima, tglSerah, tglTerima } = values;
    const params = {
      kodePegawai: pegawai,
      dokumenUrl: dokumen,
      nama,
      keterangan,
      penyerah,
      penerima,
      tglSerah,
      tglTerima,
      dibuatOleh: user?._id
    };

    // console.log(params);

    if (data?._id) {
      params.tglUbah = moment().format('YYYY-MM-DDTHH:mm:ss');
      params.dokumenId = data?.dokumen?.id;
    } else {
      params.tglBuat = moment().format('YYYY-MM-DDTHH:mm:ss');
    }

    const endpoint = data
      ? axiosPrivate.put(`dokumen/${data._id}`, params)
      : axiosPrivate.post(`dokumen/${selectedId}`, params);

    // alert(data ? `Put dokumen/${data._id}` : `Post dokumen/${selectedId}`);

    try {
      const response = await endpoint;
      const { result } = response?.data;

      handleUpdateTable(result);
      handleMessage(response?.data);

      if (!data?._id) {
        resetForm();
      }
    } catch (error) {
      handleMessage(error);
    } finally {
      setSubmitting(false);
    }
  };

  const onSetValue = (value) => {
    const pegawai = pegawais.find(pegawai => pegawai.value === value);

    setSelectedId(pegawai?._id);
  }

  return (
    <Formik
      initialValues={handleInitialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting }) => (
        <Form id={formId}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12}>
              <UploadDocField name={dokumen.name} label={dokumen.label} />
            </Grid>
            <Grid item xs={12} sm={12}>
              <AutocompleteField
                name={pegawai.name}
                label={pegawai.label}
                data={pegawais}
                onSetValue={(value) => onSetValue(value)}
                readOnly={!!data?.kodePegawai}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <InputField name={nama.name} label={nama.label} fullWidth />
            </Grid>
            <Grid item xs={12} sm={12}>
              <InputField name={keterangan.name} label={keterangan.label} fullWidth />
            </Grid>
            <Grid item xs={12} sm={12}>
              <InputField name={penerima.name} label={penerima.label} fullWidth />
            </Grid>
            <Grid item xs={12} sm={12}>
              <InputField name={penyerah.name} label={penyerah.label} fullWidth />
            </Grid>
            <Grid item xs={12} sm={12}>
              <DatePickerField
                name={tglTerima.name}
                label={tglTerima.label}
                format="dd/MM/yyyy"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <DatePickerField
                name={tglSerah.name}
                label={tglSerah.label}
                format="dd/MM/yyyy"
                fullWidth
              />
            </Grid>
          </Grid>
          <Stack direction="row" justifyContent="end" mt={2} spacing={1}>
            <Button
              variant="contained"
              color="error"
              onClick={handleCloseModal}
            >
              Kembali
            </Button>
            <LoadingButton type="submit" loading={isSubmitting} variant="contained">
              Simpan
            </LoadingButton>
          </Stack>
        </Form>
      )}
    </Formik>
  );
}
